import { useEffect, useState } from 'react'
import { fetchOembed } from '../../api/oembed'

interface Props {
  url: string
}

export function BandcampEmbed({ url }: Props) {
  const [embedUrl, setEmbedUrl] = useState<string | null>(null)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    let cancelled = false
    fetchOembed(url)
      .then((data) => { if (!cancelled) setEmbedUrl(data.embed_url) })
      .catch(() => { if (!cancelled) setFailed(true) })
    return () => { cancelled = true }
  }, [url])

  if (failed) return <a href={url}>{url}</a>
  if (!embedUrl) return null

  return (
    <div className="bandcamp-embed">
      <iframe src={embedUrl} title="bandcamp player" seamless />
    </div>
  )
}
